import React, { Component } from 'react';
import { Modal, Button, Table} from 'antd';
import moment from 'moment-timezone';
import { map } from 'lodash';
import DataTable from '../../../../Assets/data/Datatable';
import dc_invoice_logo from '../../../../Assets/images/useraccount/dc_invoice_logo.svg';
import {errorHandle} from "../../../Common/errorHandle";

class Invoice extends Component {
  state = {
    is_edit_info: false,
    invoice_data: [],
    curr_invoice: {},
    //Expand row varibale
    expandedRowKeys: '',
    invoice_pagination: { showSizeChanger: false, pageSize: 15 },
    loader: false
  }

  componentDidMount = () => {
    const accessToken = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).user?.uuid
      : "";
    this.setState({
      loader: true
    })
    this.props.getAccountListing({ limit: 15, offset: 0, user__uuid: accessToken })
    this.props.getInvoiceCreditMemoList({ limit: 15, offset: 0, user__uuid: accessToken })



  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { invoice_pagination } = this.state;
    // if (Object.keys(props.GetInvoice.data).length > 0 && props.GetInvoice.data !== this.props.GetInvoice.data) {


    //   invoice_pagination.total = props.GetInvoice.data.count
    //   this.setState({
    //     invoice_data: props.GetInvoice.data.results,
    //     loader: false
    //   })
    // }
    if (Object.keys(props.GetInvoice.InvoiceCreditMemoList).length > 0 && props.GetInvoice.InvoiceCreditMemoList !== this.props.GetInvoice.InvoiceCreditMemoList) {


      invoice_pagination.total = props.GetInvoice.InvoiceCreditMemoList.count
      this.setState({
        invoice_data: props.GetInvoice.InvoiceCreditMemoList.results,
        loader: false
      })
    }
    if (Object.keys(props.GetInvoice.errors).length > 0 && props.GetInvoice.errors !== this.props.GetInvoice.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
      errorHandle(props?.GetInvoice?.errors)

    }

    //Download Invoice
    if (Object.keys(props.DownloadInvoice.data).length > 0 && props.DownloadInvoice.data !== this.props.DownloadInvoice.data) {
      var byteCharacters = atob(props.DownloadInvoice.data?.data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      //Print Invoice
      this.setState({
        loader: false,

      });

    }
    if (Object.keys(props.DownloadInvoice.errors).length > 0 && props.DownloadInvoice.errors !== this.props.DownloadInvoice.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
      errorHandle(props?.DownloadInvoice?.errors)

    }


  }

  // Table Pagination
  invoiceChange = (pagination) => {
    let { invoice_pagination } = this.state;

    const accessToken = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).user?.uuid
      : "";


    invoice_pagination = Object.assign(invoice_pagination, { 'current': pagination.current });
    this.setState({
      invoice_pagination,
      loader: true,
    })

    this.props.getAccountListing({ offset: (pagination.current * 15) - 15, limit: 15, user__uuid: accessToken })

  }

  render() {
    let { is_edit_info, invoice_pagination, expandedRowKeys, invoice_data, curr_invoice, loader } = this.state;
    return (
      <div className="invoice_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="invoice_table ">
                <div className="table-responsive">
                  {/* Table For Web */}
                  <Table
                    rowKey={record => record.uuid}
                    dataSource={invoice_data}
                    pagination={invoice_pagination}
                    columns={DataTable.InvoiceWeb(this)}
                    onChange={this.invoiceChange}
                    className="table invoice_table invoice_table_web"
                  />


                  {/* Table For Mobile */}
                  <Table
                    rowKey={record => record.uuid}
                    dataSource={invoice_data}
                    pagination={invoice_pagination}
                    columns={DataTable.InvoiceMobile(this)}
                    onChange={this.invoiceChange}
                    className="table invoice_table invoice_table_mobile"

                    // Code for Expand row
                    expandableRowIcon={<span className="las la-filter" type="right"></span>}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={(record) => {

                      return (
                        <div className="expanded-row-block">
                          {/* Add Expand Html Here */}
                          <div className="block-row">
                            <div className="tcell">
                              <label>Type</label>
                              <span>Invoice</span>
                            </div>
                            <div className="tcell">
                              <label>Invoice #</label>
                              <span>#{record.invoice_id}</span>
                            </div>
                          </div>
                          <div className="block-row  mt-20">
                            <div className="tcell">
                              <label>Due Date</label>
                              <span>{moment(record.due_date).format("MM/DD/YYYY")}</span>
                            </div>
                            <div className="tcell">
                              <label>Balance</label>
                              <span>${record.balance_due}</span>
                            </div>
                            <div className="tcell">
                              <label>Total</label>
                              <span>${record.total_with_tax}</span>
                            </div>
                          </div>
                          <div className="block-row  mt-20">
                            <div className="tcell">
                              <label>Date Paid</label>
                              <span>{record.date_paid ? moment(record.date_paid).format('MM/DD/YYYY') : '-'}</span>
                            </div>
                            <div className="tcell">
                              <label>Payment Method</label>
                              <span>{record.payment_method_type ? record.payment_method_type : '-'}</span>
                            </div>
                          </div>
                          <div className="tcell mt-20">
                            <span onClick={() => {
                              this.setState({
                                is_edit_info: true,
                                curr_invoice: record
                              })
                            }} className="view">View Invoice</span>
                          </div>
                        </div>
                      )
                    }}
                    onExpand={(record, value) => {
                      var temp = [];

                      if (record) {
                        temp.push(value.uuid); // I have set my record.id as row key. Check the documentation for more details.
                        this.setState({ record: value })
                      }

                      this.setState({ expandedRowKeys: temp, expandeData: [] });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          className="invoice_popup"
          visible={is_edit_info}
          footer={[
            <Button key="cancel" className="btn btn-outline--primary" onClick={() => { this.setState({ is_edit_info: false, curr_invoice: {} }) }}>Close</Button>,
            // this.state.curr_invoice.invoice_date?<Button key="submit"
            //   visible={false}
            //   onClick={() => {
            //     this.setState({ loader: true });
            //     this.props.printInvoice({ multiple_invoices_uuid: curr_invoice?.uuid });
            //   }}
            //   className="btn btn--secondary"
            // >Download PDF</Button>:null
          ]}
        >
          <div className="moday_body">
            <div className="invoice_report_wrapper">
              <div className="report_header">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        <div className="company_logo">
                          <img src={dc_invoice_logo} alt="" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="report_id">#{curr_invoice?.billing_address?curr_invoice.invoice_id:curr_invoice.creditmemo_id}</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="address">
                          <label>{curr_invoice?.billing_address?"Bill to:":"Credit to:"}</label>
                          <p>
                            {curr_invoice?.user?.first_name}  {curr_invoice?.user?.last_name}, <br />
                            {curr_invoice?.billing_address?curr_invoice?.billing_address?.address +",":null}<br />
                            {curr_invoice?.billing_address?curr_invoice?.billing_address?.city+",":null}{curr_invoice?.billing_address?.state} {curr_invoice?.billing_address?.zip_code}<br />
                          </p>
                        </div>
                      </td>
                      <td align="text-right">
                        <div className="invoice">
                          <span>Date</span>
                          <p>{moment(curr_invoice.invoice_date?curr_invoice.invoice_date:curr_invoice.date_creditmemo).format("MM/DD/YYYY")}</p>
                          {curr_invoice.invoice_date?<span>Due Date</span>:null}
                          {curr_invoice.invoice_date?<p>{moment(curr_invoice.due_date).format("MM/DD/YYYY")}</p>:null}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <table className="table invoice_details_table">
                <thead>
                  <tr>
                    <th>Work Order</th>
                    <th>Service Date</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Tax</th>

                  </tr>

                </thead>
                <tbody>

                  {map(curr_invoice.line_items, (item) => {

                    return (
                      <tr key={item.uuid}>
                        <td><label className="id"> {item.service_code?item.service_code : <label className="id"></label>} </label></td>
                        <td><label className="date">{moment(item.date).format('MM/DD/YYYY')}</label></td>
                        <td><label className="desc">{item.description}</label></td>
                        <td><label className="desc">{item.quantity}</label></td>
                        <td><label className="tax1">${item.creditmemo_uuid && item?.amount>0?"-":null}{curr_invoice.invoice_date?item.price:item.amount}</label></td>
                        <td><label className="tax1">${item.creditmemo_uuid && item?.tax>0?"-":null}{item.tax}</label> <span className="tax3">{item.tax_percent}</span></td>
                      </tr>
                    )
                  })}



                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td style={{ 'minWidth': '130px' }}></td>

                    <td>
                      <p className="desc">
                        {curr_invoice?.notes}</p>
                    </td>
                    <td>
                      <ul className="total_list">
                        <li>
                          <label>Total</label>
                          <span>${curr_invoice.creditmemo_id && curr_invoice?.total>0?"-":null}{curr_invoice?.total}</span>
                        </li>
                        <li>
                          <label> Sales Tax</label>
                          <span>${curr_invoice.creditmemo_id && curr_invoice?.sales_tax>0?"-":null}{curr_invoice?.sales_tax}</span>
                        </li>
                        <li>
                          <label> {curr_invoice.invoice_date?"Amount Received":"Remaining Credit Balance"}</label>
                          <span>${curr_invoice.creditmemo_id && curr_invoice?.remaining_balance>0?"-":null}{curr_invoice.invoice_date?curr_invoice?.amount_received:curr_invoice.remaining_balance}</span>
                        </li>
                        {curr_invoice.invoice_date?<li>
                          <label> Balance Due</label>
                          <span>${curr_invoice.balance_due}</span>
                        </li>:null}
                      </ul>

                    </td>
                    <td className="border-none"></td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal >
        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div >
    );
  }
}

export default Invoice;